import React, { useEffect, useMemo, useRef, useState } from "react";
import {
  Container,
  Row,
  Card,
  Col,
  Modal,
  Form,
  Button,
  Offcanvas,
  Tab,
  Nav,
  Badge,
  ProgressBar,
} from "react-bootstrap";
import DataTable from "react-data-table-component";
import Breadcrumb from "Common/BreadCrumb";
import { Link, useLocation } from "react-router-dom";
import Swal from "sweetalert2";
import {
  useAddSmSMutation,
  useDeleteSmsEnAttenteMutation,
  useDeleteSmSMutation,
  useFetchSmSQuery,
  useSendSmSMutation,
  useFetchBalanceQuery,
} from "features/sms/smsSlice";
import { useFetchParentsQuery } from "features/parents/parentSlice";
import Select from "react-select";
import { useFetchClassesQuery } from "features/classes/classeSlice";
import { useFetchEtudiantsByClasseIdMutation } from "features/etudiants/etudiantSlice";
import shortCode from "Common/shortCode";

const ParentsSmses = () => {
  const { data = [] } = useFetchSmSQuery();
  const { data: balanceData } = useFetchBalanceQuery();
  const { data: AllParents = [] } = useFetchParentsQuery();
  const { data: AllClasses = [] } = useFetchClassesQuery();
  const filteredShortCode = shortCode.filter((item) => item.id !== 6);
  const [fetchEtudiantsByClasseId] = useFetchEtudiantsByClasseIdMutation();
  const [deleteSms] = useDeleteSmSMutation();
  const [deleteSmsEnAttente, { isLoading: isDeletingPendingSmsLoading }] = useDeleteSmsEnAttenteMutation();

  const pending_sms = data.filter((sms) => sms.status === "Pending");

  const [showDestinataire, setShowDestinataire] = useState(false);
  const [activeTab, setActiveTab] = useState("arrow-overview");
  const [statusFilter, setStatusFilter] = useState<"all" | "sent" | "Pending">("all");

  const handleSelect = (selectedKey: any) => setActiveTab(selectedKey);

  const notifySuccess = () => {
    Swal.fire({ position: "center", icon: "success", title: "Message créé avec succès", showConfirmButton: false, timer: 2500 });
  };

  const notifyError = (err: any) => {
    Swal.fire({ position: "center", icon: "error", title: `Erreur: ${err}`, showConfirmButton: false, timer: 2500 });
  };

  const swalWithBootstrapButtons = Swal.mixin({
    customClass: { confirmButton: "btn btn-success", cancelButton: "btn btn-danger" },
    buttonsStyling: false,
  });

  const AlertDelete = async (ids: string[]) => {
    swalWithBootstrapButtons
      .fire({
        title: "Êtes-vous sûr ?",
        text: "Cette action est irréversible !",
        icon: "warning",
        showCancelButton: true,
        confirmButtonText: "Oui, supprimer",
        cancelButtonText: "Annuler",
        reverseButtons: true,
      })
      .then((result) => {
        if (result.isConfirmed) {
          deleteSms(ids);
          swalWithBootstrapButtons.fire("Supprimé", "Messages supprimés.", "success");
        }
      });
  };

  const AlertDeletePendingSms = async () => {
    swalWithBootstrapButtons
      .fire({
        title: "Supprimer les SMS en attente ?",
        text: "Tous les SMS en attente seront supprimés.",
        icon: "warning",
        showCancelButton: true,
        confirmButtonText: "Oui, supprimer tout",
        cancelButtonText: "Annuler",
        reverseButtons: true,
      })
      .then((result) => {
        if (result.isConfirmed) {
          deleteSmsEnAttente();
          swalWithBootstrapButtons.fire("Nettoyé", "SMS en attente supprimés.", "success");
        }
      });
  };

  const [isChecked, setIsChecked] = useState(true);

  const handleCheckboxChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    setIsChecked(event.target.checked);
    setSms((prev) => ({ ...prev, include_names: event.target.checked ? "1" : "0" }));
  };

  const [modal_AddSms, setmodal_AddSms] = useState(false);
  const tog_AddSms = () => setmodal_AddSms(!modal_AddSms);

  const handleReload = () => window.location.reload();

  const [createSms, { isLoading: loadingCreateSms }] = useAddSmSMutation();
  const [sendSms, { isLoading }] = useSendSmSMutation();

  const handleSendSms = async () => {
    try {
      await sendSms().then(() => handleReload);
    } catch (error) {
      console.error("Error sending SMS:", error);
    }
  };

  const initialSms = {
    sender: "",
    receivers: [""],
    msg: "",
    status: "",
    include_names: "1",
    specefic_students: [""],
    total_sms: "",
    sms_par_destinataire: "",
  };

  const [sms, setSms] = useState(initialSms);
  const [students, setStudents] = useState<any[]>([]);
  const { msg, receivers } = sms;

  const optionColumnsTable = AllClasses.map((classe: any) => ({
    value: classe?._id!,
    label: `${classe?.nom_classe!}`,
  }));

  const [selectedColumnValues, setSelectedColumnValues] = useState<any[]>([]);

  const handleSelectValueColumnChange = async (selectedOption: any) => {
    const values = selectedOption.map((option: any) => option.value);
    setSelectedColumnValues(values);
    let apiStudents = [];
    for (const classID of values) {
      const result = await fetchEtudiantsByClasseId(classID).unwrap();
      for (const eleve of result) apiStudents.push(eleve);
    }
    setStudents(apiStudents);
  };

  const optionEleves = students.map((eleve: any) => ({
    value: eleve?._id!,
    label: `${eleve?.prenom!} ${eleve?.nom!}`,
  }));

  const [selectedElevesValues, setSelectedEleveValues] = useState<any[]>([]);
  const handleSelectEleveChange = (selectedOption: any) => {
    setSelectedEleveValues(selectedOption.map((o: any) => o.value));
  };

  useEffect(() => {
    if (AllParents.length > 0) {
      if (activeTab === "arrow-overview") {
        const parentIds = AllParents.map((parent) => parent?._id!);
        setSms((prev) => ({ ...prev, receivers: parentIds }));
      } else if (activeTab === "arrow-profile") {
        if (selectedColumnValues.length === 1) {
          setSms((prev) => ({ ...prev, receivers: [""], specefic_students: selectedElevesValues }));
        } else {
          setSms((prev) => ({ ...prev, receivers: [""], specefic_students: students }));
        }
      }
    }
  }, [AllParents, activeTab, selectedColumnValues, selectedElevesValues, students]);

  const onChangeSms = (e: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement>) => {
    setSms((prev) => ({ ...prev, [e.target.id]: e.target.value }));
  };

  const calculateSmsCount = (messageLength: number, checked: boolean) => {
    let firstLimit = checked ? 127 : 157;
    let subsequentLimit = 157;
    if (messageLength <= firstLimit) return 1;
    let smsCount = 1;
    messageLength -= firstLimit;
    smsCount += Math.ceil(messageLength / subsequentLimit);
    return smsCount;
  };

  const numberOfSms = calculateSmsCount(msg.length, isChecked);
  let totalSms = numberOfSms * receivers.length;

  const onSubmitSms = (e: React.FormEvent<HTMLFormElement>) => {
    e.preventDefault();
    try {
      sms["sender"] = "SLS Sousse";
      sms["status"] = "Pending";
      sms["total_sms"] = totalSms.toString();
      sms["sms_par_destinataire"] = numberOfSms.toString();
      createSms(sms)
        .then(() => notifySuccess())
        .then(() => setSms(initialSms));
    } catch (error) {
      notifyError(error);
    }
  };

  const groupedData = Object.values(
    data.reduce((acc: any, current: any) => {
      const { msg } = current;
      if (!acc[msg]) {
        acc[msg] = { ...current, receiversCount: [current] };
      } else {
        acc[msg].receiversCount.push(current);
      }
      return acc;
    }, {})
  );

  const [searchTerm, setSearchTerm] = useState("");

  const getFilteredData = () => {
    let filtered = [...groupedData].reverse();
    if (searchTerm) {
      const term = searchTerm.toLowerCase();
      filtered = filtered.filter((row: any) =>
        row.msg?.toLowerCase().includes(term) ||
        row.createdAt?.toLowerCase().includes(term) ||
        String(row.receiversCount?.length || "").includes(term)
      );
    }
    if (statusFilter !== "all") {
      filtered = filtered.filter((row: any) => row.status === statusFilter);
    }
    return filtered;
  };

  const stats = useMemo(() => {
    const sent = data.filter((s: any) => s.status === "sent").length;
    const pending = data.filter((s: any) => s.status === "Pending").length;
    return { total: data.length, sent, pending };
  }, [data]);

  const balance = balanceData?.data?.balance ?? null;

  const charLimit = isChecked ? 127 : 157;
  const charPercent = Math.min((msg.length / charLimit) * 100, 100);
  const charColor = charPercent > 90 ? "danger" : charPercent > 70 ? "warning" : "primary";

  const columns = [
    {
      name: <span className="fw-semibold fs-13">Message</span>,
      selector: (row: any) => row.msg,
      cell: (row: any) => (
        <div className="py-2" style={{ maxWidth: 350 }}>
          <span className="text-dark fs-13 d-block text-truncate" style={{ maxWidth: 350 }}>
            {row.msg}
          </span>
          <small className="text-muted fs-11">
            {row.receiversCount?.length} destinataire(s) · {row.sms_par_destinataire} SMS/dest.
          </small>
        </div>
      ),
      sortable: true,
      grow: 3,
    },
    {
      name: <span className="fw-semibold fs-13">Destinataires</span>,
      selector: (row: any) => row.receiversCount?.length || 0,
      cell: (row: any) => (
        <Link
          to="#"
          state={row}
          onClick={() => setShowDestinataire(true)}
          className="text-decoration-none"
        >
          <Badge bg="primary-subtle" text={"primary" as any} className="fs-12 px-2 py-1">
            <i className="ri-group-line me-1" />
            {row.receiversCount.length}
          </Badge>
        </Link>
      ),
      sortable: true,
      width: "120px",
    },
    {
      name: <span className="fw-semibold fs-13">Total SMS</span>,
      selector: (row: any) => Number(row.total_sms) || 0,
      cell: (row: any) => (
        <span className="fw-medium fs-13">{row.total_sms}</span>
      ),
      sortable: true,
      width: "100px",
    },
    {
      name: <span className="fw-semibold fs-13">Date & Heure</span>,
      selector: (row: any) => row.createdAt || "",
      cell: (row: any) => {
        if (!row.createdAt) return <span className="text-muted fs-12">—</span>;
        const d = new Date(row.createdAt);
        return (
          <div className="fs-12">
            <span className="d-block fw-medium">{d.toLocaleDateString("fr-FR", { day: "2-digit", month: "short", year: "numeric" })}</span>
            <small className="text-muted">{d.toLocaleTimeString("fr-FR", { hour: "2-digit", minute: "2-digit" })}</small>
          </div>
        );
      },
      sortable: true,
      width: "140px",
    },
    {
      name: <span className="fw-semibold fs-13">Statut</span>,
      selector: (row: any) => row.status,
      cell: (row: any) => {
        if (row.status === "sent") {
          return (
            <Badge bg="success-subtle" text={"success" as any} className="fs-12 px-2 py-1">
              <i className="ri-check-double-line me-1" />Envoyé
            </Badge>
          );
        }
        return (
          <Badge bg="warning-subtle" text={"warning" as any} className="fs-12 px-2 py-1">
            <i className="ri-time-line me-1" />En attente
          </Badge>
        );
      },
      sortable: true,
      width: "120px",
    },
    {
      name: <span className="fw-semibold fs-13">Actions</span>,
      cell: (row: any) => {
        const idsToDelete = row.receiversCount.map((sms: any) => sms._id);
        return (
          <div className="d-flex gap-1">
            <button
              className="btn btn-soft-info btn-sm btn-icon"
              onClick={() => setShowDestinataire(true)}
              title="Voir destinataires"
            >
              <i className="ri-eye-line" />
            </button>
            {row.status === "Pending" && (
              <button
                className="btn btn-soft-danger btn-sm btn-icon"
                onClick={() => AlertDelete(idsToDelete)}
                title="Supprimer"
              >
                <i className="ri-delete-bin-2-line" />
              </button>
            )}
          </div>
        );
      },
      width: "80px",
    },
  ];

  const textareaRef1 = useRef<HTMLTextAreaElement>(null);
  const textareaRef2 = useRef<HTMLTextAreaElement>(null);
  const destinataireLocation = useLocation();

  const handleShortcodeClick = (code: string, textareaRef: React.RefObject<HTMLTextAreaElement>) => {
    if (textareaRef.current) {
      const textarea = textareaRef.current;
      const start = textarea.selectionStart;
      const end = textarea.selectionEnd;
      const newText = sms.msg.slice(0, start) + code + sms.msg.slice(end);
      setSms((prev) => ({ ...prev, msg: newText }));
      setTimeout(() => {
        textarea.setSelectionRange(start + code.length, start + code.length);
        textarea.focus();
      }, 0);
    }
  };

  const customStyles = {
    headCells: {
      style: {
        backgroundColor: "#f3f6f9",
        fontWeight: "600",
        fontSize: "13px",
        color: "#495057",
        borderBottom: "2px solid #e9ebec",
      },
    },
    rows: {
      style: {
        fontSize: "13px",
        "&:hover": { backgroundColor: "#f3f6f9" },
      },
    },
    pagination: {
      style: { borderTop: "1px solid #e9ebec" },
    },
  };

  const SmsPreview = () => {
    if (!msg) return null;
    let preview = msg;
    if (isChecked) preview = "Cher(e) parent de [Prénom Nom], " + preview;
    return (
      <div className="mt-3 p-3 rounded-3" style={{ background: "#e8f4e8", border: "1px solid #c3e6c3", maxWidth: 350 }}>
        <div className="d-flex align-items-center gap-2 mb-2">
          <i className="ri-smartphone-line text-success" />
          <small className="fw-semibold text-success">Aperçu SMS</small>
        </div>
        <div className="bg-white rounded-3 p-2 fs-12" style={{ fontFamily: "monospace", lineHeight: 1.5, wordBreak: "break-word" }}>
          {preview}
        </div>
        <div className="d-flex justify-content-between mt-2">
          <small className="text-muted">{preview.length} caractères</small>
          <small className="text-muted">{numberOfSms} SMS</small>
        </div>
      </div>
    );
  };

  return (
    <React.Fragment>
      <div className="page-content">
        <Container fluid>
          <Breadcrumb title="SMS Parents" pageTitle="Tableau de bord" />

          {/* KPI Cards */}
          <Row className="mb-3">
            <Col sm={6} xl={3}>
              <Card className="card-animate border-0 shadow-sm">
                <Card.Body>
                  <div className="d-flex align-items-center">
                    <div className="avatar-sm flex-shrink-0">
                      <span className="avatar-title bg-primary-subtle text-primary rounded-circle fs-3">
                        <i className="ri-message-2-line" />
                      </span>
                    </div>
                    <div className="flex-grow-1 ms-3">
                      <p className="text-uppercase fw-medium text-muted mb-1 fs-13">Total Messages</p>
                      <h4 className="mb-0">{stats.total}</h4>
                    </div>
                  </div>
                </Card.Body>
              </Card>
            </Col>
            <Col sm={6} xl={3}>
              <Card className="card-animate border-0 shadow-sm">
                <Card.Body>
                  <div className="d-flex align-items-center">
                    <div className="avatar-sm flex-shrink-0">
                      <span className="avatar-title bg-success-subtle text-success rounded-circle fs-3">
                        <i className="ri-check-double-line" />
                      </span>
                    </div>
                    <div className="flex-grow-1 ms-3">
                      <p className="text-uppercase fw-medium text-muted mb-1 fs-13">Envoyés</p>
                      <h4 className="mb-0 text-success">{stats.sent}</h4>
                    </div>
                  </div>
                </Card.Body>
              </Card>
            </Col>
            <Col sm={6} xl={3}>
              <Card className="card-animate border-0 shadow-sm">
                <Card.Body>
                  <div className="d-flex align-items-center">
                    <div className="avatar-sm flex-shrink-0">
                      <span className="avatar-title bg-warning-subtle text-warning rounded-circle fs-3">
                        <i className="ri-time-line" />
                      </span>
                    </div>
                    <div className="flex-grow-1 ms-3">
                      <p className="text-uppercase fw-medium text-muted mb-1 fs-13">En Attente</p>
                      <h4 className="mb-0 text-warning">{stats.pending}</h4>
                    </div>
                  </div>
                </Card.Body>
              </Card>
            </Col>
            <Col sm={6} xl={3}>
              <Card className="card-animate border-0 shadow-sm">
                <Card.Body>
                  <div className="d-flex align-items-center">
                    <div className="avatar-sm flex-shrink-0">
                      <span className="avatar-title bg-info-subtle text-info rounded-circle fs-3">
                        <i className="ri-wallet-3-line" />
                      </span>
                    </div>
                    <div className="flex-grow-1 ms-3">
                      <p className="text-uppercase fw-medium text-muted mb-1 fs-13">Solde SMS</p>
                      <h4 className="mb-0 text-info">
                        {balance !== null ? `${Number(balance).toFixed(2)} DT` : "—"}
                      </h4>
                    </div>
                  </div>
                </Card.Body>
              </Card>
            </Col>
          </Row>

          {/* Data Table */}
          <Col lg={12}>
            <Card className="border-0 shadow-sm">
              <Card.Header className="border-bottom-dashed bg-white">
                <Row className="g-3 align-items-center">
                  <Col lg={3} md={5}>
                    <div className="search-box">
                      <input
                        type="text"
                        className="form-control search"
                        placeholder="Rechercher un message..."
                        value={searchTerm}
                        onChange={(e) => setSearchTerm(e.target.value)}
                      />
                      <i className="ri-search-line search-icon"></i>
                    </div>
                  </Col>
                  <Col lg={3} md={3}>
                    <div className="d-flex gap-1">
                      <Button
                        variant={statusFilter === "all" ? "primary" : "soft-secondary"}
                        size="sm"
                        onClick={() => setStatusFilter("all")}
                      >
                        Tous <Badge bg="light" text={"dark" as any} className="ms-1">{groupedData.length}</Badge>
                      </Button>
                      <Button
                        variant={statusFilter === "sent" ? "success" : "soft-secondary"}
                        size="sm"
                        onClick={() => setStatusFilter("sent")}
                      >
                        Envoyés
                      </Button>
                      <Button
                        variant={statusFilter === "Pending" ? "warning" : "soft-secondary"}
                        size="sm"
                        onClick={() => setStatusFilter("Pending")}
                      >
                        En attente
                      </Button>
                    </div>
                  </Col>
                  <Col lg={6} md={4} className="d-flex justify-content-end gap-2 flex-wrap">
                    {pending_sms.length > 0 && (
                      <Button
                        variant="soft-danger"
                        size="sm"
                        onClick={AlertDeletePendingSms}
                        disabled={isDeletingPendingSmsLoading}
                        className="d-flex align-items-center gap-1"
                      >
                        <i className="ri-delete-bin-2-line" />
                        {isDeletingPendingSmsLoading ? "Nettoyage..." : "Vider en attente"}
                      </Button>
                    )}
                    {isLoading ? (
                      <Button variant="outline-primary" size="sm" disabled className="d-flex align-items-center gap-1">
                        <span className="spinner-border spinner-border-sm" />
                        Envoi...
                      </Button>
                    ) : (
                      <Button
                        variant="success"
                        size="sm"
                        onClick={handleSendSms}
                        disabled={pending_sms.length === 0}
                        className="d-flex align-items-center gap-1"
                      >
                        <i className="ri-send-plane-line" />
                        Envoyer ({pending_sms.length})
                      </Button>
                    )}
                    <Button
                      variant="primary"
                      onClick={tog_AddSms}
                      disabled={loadingCreateSms}
                      className="d-flex align-items-center gap-1"
                    >
                      {loadingCreateSms ? (
                        <span className="spinner-border spinner-border-sm" />
                      ) : (
                        <i className="ri-add-line" />
                      )}
                      Nouveau message
                    </Button>
                  </Col>
                </Row>
              </Card.Header>
              <Card.Body className="p-0">
                <DataTable
                  columns={columns}
                  data={getFilteredData()}
                  pagination
                  paginationPerPage={15}
                  paginationRowsPerPageOptions={[10, 15, 25, 50]}
                  customStyles={customStyles}
                  noDataComponent={
                    <div className="text-center py-5">
                      <i className="ri-message-2-line fs-1 text-muted d-block mb-2" />
                      <p className="text-muted mb-0">
                        {statusFilter !== "all" ? "Aucun message avec ce filtre" : "Aucun message trouvé"}
                      </p>
                    </div>
                  }
                  paginationComponentOptions={{
                    rowsPerPageText: "Lignes par page",
                    rangeSeparatorText: "sur",
                  }}
                  highlightOnHover
                  responsive
                />
              </Card.Body>
            </Card>
          </Col>

          {/* Add Modal */}
          <Modal
            className="fade"
            show={modal_AddSms}
            onHide={tog_AddSms}
            centered
            size="xl"
          >
            <Modal.Header closeButton className="bg-primary-subtle">
              <h5 className="modal-title d-flex align-items-center gap-2">
                <i className="ri-mail-send-line" />
                Nouveau message SMS
              </h5>
            </Modal.Header>
            <Modal.Body>
              <Form className="create-form" onSubmit={onSubmitSms}>
                <Tab.Container defaultActiveKey="arrow-overview" onSelect={handleSelect}>
                  <Nav as="ul" variant="pills" className="arrow-navtabs nav-success bg-light mb-3 rounded-2 p-1">
                    <Nav.Item as="li">
                      <Nav.Link eventKey="arrow-overview" className="rounded-2">
                        <i className="ri-group-line me-1" />
                        Tous les parents
                      </Nav.Link>
                    </Nav.Item>
                    <Nav.Item as="li">
                      <Nav.Link eventKey="arrow-profile" className="rounded-2">
                        <i className="ri-filter-line me-1" />
                        Par classe
                      </Nav.Link>
                    </Nav.Item>
                  </Nav>
                  <Tab.Content>
                    <Tab.Pane eventKey="arrow-overview">
                      <div className="d-flex align-items-center gap-2 mb-3 p-2 rounded-2" style={{ background: "#f0f4fb" }}>
                        <i className="ri-information-line text-primary" />
                        <small className="text-muted">
                          Ce message sera envoyé à <strong>{AllParents.length} parents</strong> — tous les parents enregistrés.
                        </small>
                      </div>
                      <Row>
                        <Col lg={8}>
                          <Form.Label className="fw-semibold">
                            <i className="ri-edit-line me-1 text-primary" />
                            Message
                          </Form.Label>
                          <div className="form-check mb-2">
                            <input
                              className="form-check-input"
                              type="checkbox"
                              id="formCheck1"
                              checked={isChecked}
                              onChange={handleCheckboxChange}
                            />
                            <label className="form-check-label fs-13" htmlFor="formCheck1">
                              Inclure le nom de l'élève au début du message
                            </label>
                          </div>
                          <textarea
                            className="form-control"
                            id="msg"
                            name="msg"
                            value={sms.msg}
                            onChange={onChangeSms}
                            ref={textareaRef1}
                            rows={7}
                            placeholder="Tapez votre message ici..."
                            style={{ resize: "vertical" }}
                          />
                          <div className="mt-2">
                            <div className="d-flex justify-content-between mb-1">
                              <small className="text-muted">{msg.length} caractères</small>
                              <small className={`text-${charColor} fw-semibold`}>{numberOfSms} SMS par destinataire</small>
                            </div>
                            <ProgressBar
                              now={charPercent}
                              variant={charColor}
                              style={{ height: 4 }}
                            />
                          </div>
                          <SmsPreview />
                        </Col>
                        <Col lg={4}>
                          <Form.Label className="fw-semibold mb-2">
                            <i className="ri-code-s-slash-line me-1 text-primary" />
                            Variables dynamiques
                          </Form.Label>
                          <div className="d-flex flex-wrap gap-1">
                            {filteredShortCode.map((code) => (
                              <Button
                                key={code.id}
                                type="button"
                                variant="soft-primary"
                                size="sm"
                                className="rounded-pill"
                                onClick={() => handleShortcodeClick(code.code, textareaRef1)}
                              >
                                {code.name}
                              </Button>
                            ))}
                          </div>
                          <div className="mt-3 p-3 rounded-3 bg-light">
                            <h6 className="fs-13 fw-semibold mb-2">
                              <i className="ri-bar-chart-line me-1" />
                              Résumé
                            </h6>
                            <div className="d-flex justify-content-between fs-13 mb-1">
                              <span className="text-muted">Destinataires</span>
                              <span className="fw-medium">{receivers.length}</span>
                            </div>
                            <div className="d-flex justify-content-between fs-13 mb-1">
                              <span className="text-muted">SMS / destinataire</span>
                              <span className="fw-medium">{numberOfSms}</span>
                            </div>
                            <hr className="my-2" />
                            <div className="d-flex justify-content-between fs-13">
                              <span className="fw-semibold">Total SMS</span>
                              <span className="fw-bold text-primary">{totalSms}</span>
                            </div>
                          </div>
                        </Col>
                      </Row>
                    </Tab.Pane>
                    <Tab.Pane eventKey="arrow-profile">
                      <Row className="mb-3">
                        <Col lg={6}>
                          <Form.Label className="fw-semibold">
                            <i className="ri-folder-line me-1 text-primary" />
                            Sélectionner les classes
                          </Form.Label>
                          <Select
                            closeMenuOnSelect={false}
                            isMulti
                            options={optionColumnsTable}
                            onChange={handleSelectValueColumnChange}
                            placeholder="Choisir une ou plusieurs classes..."
                          />
                        </Col>
                        {selectedColumnValues.length === 1 && (
                          <Col lg={6}>
                            <Form.Label className="fw-semibold">
                              <i className="ri-user-line me-1 text-primary" />
                              Sélectionner les élèves
                            </Form.Label>
                            <Select
                              closeMenuOnSelect={false}
                              isMulti
                              options={optionEleves}
                              onChange={handleSelectEleveChange}
                              placeholder="Choisir des élèves..."
                            />
                          </Col>
                        )}
                      </Row>
                      {selectedColumnValues.length > 0 && (
                        <div className="d-flex align-items-center gap-2 mb-3 p-2 rounded-2" style={{ background: "#fff8e6" }}>
                          <i className="ri-information-line text-warning" />
                          <small className="text-muted">
                            {selectedColumnValues.length === 1 && selectedElevesValues.length > 0
                              ? `${selectedElevesValues.length} élève(s) sélectionné(s)`
                              : `${students.length} élève(s) dans ${selectedColumnValues.length} classe(s)`}
                          </small>
                        </div>
                      )}
                      <Row>
                        <Col lg={8}>
                          <Form.Label className="fw-semibold">
                            <i className="ri-edit-line me-1 text-primary" />
                            Message
                          </Form.Label>
                          <div className="form-check mb-2">
                            <input
                              className="form-check-input"
                              type="checkbox"
                              id="formCheck2"
                              checked={isChecked}
                              onChange={handleCheckboxChange}
                            />
                            <label className="form-check-label fs-13" htmlFor="formCheck2">
                              Inclure le nom de l'élève au début du message
                            </label>
                          </div>
                          <textarea
                            className="form-control"
                            id="msg"
                            name="msg"
                            value={sms.msg}
                            onChange={onChangeSms}
                            ref={textareaRef2}
                            rows={7}
                            placeholder="Tapez votre message ici..."
                            style={{ resize: "vertical" }}
                          />
                          <div className="mt-2">
                            <div className="d-flex justify-content-between mb-1">
                              <small className="text-muted">{msg.length} caractères</small>
                              <small className={`text-${charColor} fw-semibold`}>{numberOfSms} SMS par destinataire</small>
                            </div>
                            <ProgressBar now={charPercent} variant={charColor} style={{ height: 4 }} />
                          </div>
                          <SmsPreview />
                        </Col>
                        <Col lg={4}>
                          <Form.Label className="fw-semibold mb-2">
                            <i className="ri-code-s-slash-line me-1 text-primary" />
                            Variables dynamiques
                          </Form.Label>
                          <div className="d-flex flex-wrap gap-1">
                            {filteredShortCode.map((code) => (
                              <Button
                                key={code.id}
                                type="button"
                                variant="soft-primary"
                                size="sm"
                                className="rounded-pill"
                                onClick={() => handleShortcodeClick(code.code, textareaRef2)}
                              >
                                {code.name}
                              </Button>
                            ))}
                          </div>
                          <div className="mt-3 p-3 rounded-3 bg-light">
                            <h6 className="fs-13 fw-semibold mb-2">
                              <i className="ri-bar-chart-line me-1" />
                              Résumé
                            </h6>
                            <div className="d-flex justify-content-between fs-13 mb-1">
                              <span className="text-muted">Classes</span>
                              <span className="fw-medium">{selectedColumnValues.length}</span>
                            </div>
                            <div className="d-flex justify-content-between fs-13 mb-1">
                              <span className="text-muted">Élèves</span>
                              <span className="fw-medium">
                                {selectedColumnValues.length === 1 ? selectedElevesValues.length : students.length}
                              </span>
                            </div>
                            <div className="d-flex justify-content-between fs-13 mb-1">
                              <span className="text-muted">SMS / destinataire</span>
                              <span className="fw-medium">{numberOfSms}</span>
                            </div>
                            <hr className="my-2" />
                            <div className="d-flex justify-content-between fs-13">
                              <span className="fw-semibold">Total SMS</span>
                              <span className="fw-bold text-primary">{totalSms}</span>
                            </div>
                          </div>
                        </Col>
                      </Row>
                    </Tab.Pane>
                  </Tab.Content>
                </Tab.Container>
                <hr />
                <div className="d-flex justify-content-end gap-2">
                  <Button variant="light" onClick={() => { tog_AddSms(); setSms(initialSms); }}>
                    Annuler
                  </Button>
                  <Button type="submit" variant="success" disabled={!msg.trim()}>
                    <i className="ri-check-line me-1" />
                    Ajouter aux SMS en attente
                  </Button>
                </div>
              </Form>
            </Modal.Body>
          </Modal>

          {/* Destinataire Offcanvas */}
          <Offcanvas
            show={showDestinataire}
            onHide={() => setShowDestinataire(false)}
            placement="end"
            style={{ width: "420px" }}
          >
            <Offcanvas.Header closeButton className="border-bottom bg-light">
              <Offcanvas.Title className="d-flex align-items-center gap-2">
                <i className="ri-group-line text-primary fs-20" />
                Destinataires
                <Badge bg="primary-subtle" text={"primary" as any} className="fs-12">
                  {destinataireLocation?.state?.receiversCount?.length || 0}
                </Badge>
              </Offcanvas.Title>
            </Offcanvas.Header>
            <Offcanvas.Body className="p-0">
              {destinataireLocation?.state?.receiversCount?.map((msg: any, idx: number) => (
                <div key={idx} className="d-flex align-items-center gap-3 px-3 py-2 border-bottom border-bottom-dashed">
                  <div className="avatar-xs flex-shrink-0">
                    <div className="avatar-title bg-primary-subtle text-primary rounded-circle fs-14">
                      {msg?.eleve?.prenom?.[0]}{msg?.eleve?.nom?.[0]}
                    </div>
                  </div>
                  <div className="flex-grow-1">
                    <span className="fw-medium d-block fs-13">
                      {msg?.eleve?.prenom} {msg?.eleve?.nom}
                    </span>
                    <small className="text-muted">{msg?.eleve?.classe?.nom_classe || "—"}</small>
                  </div>
                  <span className="text-muted fs-12">
                    <i className="ri-phone-line me-1" />
                    {msg?.receiver?.phone}
                  </span>
                </div>
              ))}
            </Offcanvas.Body>
          </Offcanvas>
        </Container>
      </div>
    </React.Fragment>
  );
};
export default ParentsSmses;
